/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as AnnouncementBannerDefault } from './announcement-banner-default.story';
export { default as AnnouncementBannerVariants } from './announcement-banner-variants.story';
export { default as AnnouncementBannerCustomIcons } from './announcement-banner-custom-icons.story';
export { default as AnnouncementBannerCloseable } from './announcement-banner-closeable.story';
export { default as AnnouncementBannerWithActions } from './announcement-banner-with-actions.story';
export { default as AnnouncementBannerWithPageContent } from './announcement-banner-with-page-content.story';
export { default as AnnouncementBannerPresentAtPageRender } from './announcement-banner-present-at-page-render.story';
export { default as AnnouncementBannerInjectedNonUrgent } from './announcement-banner-injected-non-urgent.story';
export { default as AnnouncementBannerInjectedUrgent } from './announcement-banner-injected-urgent.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import AnnouncementBannerCloseableSrcRaw from './announcement-banner-closeable.story?raw';
import AnnouncementBannerCustomIconsSrcRaw from './announcement-banner-custom-icons.story?raw';
import AnnouncementBannerDefaultSrcRaw from './announcement-banner-default.story?raw';
import AnnouncementBannerInjectedNonUrgentSrcRaw from './announcement-banner-injected-non-urgent.story?raw';
import AnnouncementBannerInjectedUrgentSrcRaw from './announcement-banner-injected-urgent.story?raw';
import AnnouncementBannerPresentAtPageRenderSrcRaw from './announcement-banner-present-at-page-render.story?raw';
import AnnouncementBannerVariantsSrcRaw from './announcement-banner-variants.story?raw';
import AnnouncementBannerWithActionsSrcRaw from './announcement-banner-with-actions.story?raw';
import AnnouncementBannerWithPageContentSrcRaw from './announcement-banner-with-page-content.story?raw';

export const AnnouncementBannerDefaultSrc = removeLicenseHeader(
  AnnouncementBannerDefaultSrcRaw,
);

export const AnnouncementBannerVariantsSrc = removeLicenseHeader(
  AnnouncementBannerVariantsSrcRaw,
);

export const AnnouncementBannerCustomIconsSrc = removeLicenseHeader(
  AnnouncementBannerCustomIconsSrcRaw,
);

export const AnnouncementBannerCloseableSrc = removeLicenseHeader(
  AnnouncementBannerCloseableSrcRaw,
);

export const AnnouncementBannerWithActionsSrc = removeLicenseHeader(
  AnnouncementBannerWithActionsSrcRaw,
);

export const AnnouncementBannerWithPageContentSrc = removeLicenseHeader(
  AnnouncementBannerWithPageContentSrcRaw,
);

export const AnnouncementBannerPresentAtPageRenderSrc = removeLicenseHeader(
  AnnouncementBannerPresentAtPageRenderSrcRaw,
);

export const AnnouncementBannerInjectedNonUrgentSrc = removeLicenseHeader(
  AnnouncementBannerInjectedNonUrgentSrcRaw,
);

export const AnnouncementBannerInjectedUrgentSrc = removeLicenseHeader(
  AnnouncementBannerInjectedUrgentSrcRaw,
);
